import React, { useEffect, useState } from 'react';
import { LineChart, Line } from 'recharts';
import { Box, Card, CardContent, Typography, LinearProgress, CircularProgress, Avatar, TablePagination } from '@mui/material';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Chip,
  Select,
  MenuItem
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { analysistab, getanalysis } from '../../../components/Apis';
import Swal from 'sweetalert2';
import axios from "axios";


const data = [
  { value: 65 },
  { value: 59 },
  { value: 80 },
  { value: 81 },
  { value: 56 },
  { value: 55 },
  { value: 40 }
];

const maintenanceRecords = [
  {
    UnitName: 'Villa Sahel',
    Name: 'Villa Sahel',
    Status: 'Paid',
    Date: '12/3/2024',
    Amount: '35$'
  },
  {
    UnitName: 'Villa Sahel',
    Name: 'Villa Sahel',
    Status: 'Non - Paid',
    Date: '12/3/2024',
    Amount: '35$'
  }
];

const Analysis = () => {
  const [analysis, setanalysis] = useState([]);
  const [analysischarts, setanalysischarts] = useState([]);
  console.log(analysischarts)
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page
  const [dataAnalysis, setDataAnalysis] = useState()

  // const fetchanalysis = async () => {
  //   Swal.fire({
  //     title: 'Loading...',
  //     text: 'Please wait while we load the data.',
  //     didOpen: () => Swal.showLoading(),
  //   });

  //   try {
  //     const response = await analysistab();
  //     setanalysis(response.payments);
  //     setanalysischarts(response);
  //     setDataAnalysis(response.data);
  //     console.log("this is ", dataAnalysis)

  //     Swal.close();
  //   } catch (error) {
  //     console.error(error.message);
  //     Swal.close();
  //   }
  // };
  // useEffect(() => {

  //   fetchanalysis();
  // }, []);
  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Paginated data
  const paginatedData = analysis.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  useEffect(() => {
    console.log('fetching data')
    axios
      .get("https://app.baskeg.com/api/v1/owners/units-analysis", {
        headers: {
          // Add Authorization header if required:
          Authorization: "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2Jhc2suYWRkaWN0YWNvLndlYnNpdGUvYXBpL3YxL293bmVycy9hdXRoL2xvZ2luIiwiaWF0IjoxNzM3OTc4ODcwLCJleHAiOjE3Mzc5ODYwNzAsIm5iZiI6MTczNzk3ODg3MCwianRpIjoibTZDNm5hdXE2MzFQSzhXbCIsInN1YiI6IjEyYTRhNGRlLTcwOGItNDBiYi04ZmQxLWRlYTAyZTBmNTJhYiIsInBydiI6ImEyZGMwNmUzZjY5YjEyMmQ1YWQzOTViOGVkMTQwOTMxOWQxZmU2NjYifQ.22Je27k66yUMzpBmYyQPGLaTE2X4HMHybjFsMgeCaFM",
        },
      })
      .then((response) => {
        setDataAnalysis(response.data); // Store the response data
        console.log(" this is ",response.data); // Log the response data for debugging
      })
      .catch((err) => {
        console.error(err.message); // Handle error
      })
  }, []);

  return (
    <>
      <Box display="grid" gridTemplateColumns="repeat(3, 1fr)" gap={4} marginTop={10}>
        {/* Revenue Card */}
        <Card>
          <CardContent>
            <Typography variant="subtitle1" color="textSecondary" gutterBottom>
              Revenue
            </Typography>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h5" fontWeight="bold">
                {analysischarts.net_revenue}
              </Typography>

            </Box>
            <Box height={60} mt={2}>
              <LineChart width={200} height={60} data={data}>
                <Line
                  type="monotone"
                  dataKey="value"
                  stroke="#22c55e"
                  strokeWidth={2}
                  dot={false}
                />
              </LineChart>
            </Box>
          </CardContent>
        </Card>

        {/* Units Card */}
        <Card>
          <CardContent>
            <Typography variant="subtitle1" color="textSecondary" gutterBottom>
              Units
            </Typography>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h5" fontWeight="bold">
                {analysischarts.total_units}
              </Typography>
              <Box display="flex" justifyContent="center">
                <CircularProgress
                  variant="determinate"
                  value={75}
                  size={60}
                  thickness={8}
                  color="primary"
                  sx={{
                    '& .MuiCircularProgress-circle': {
                      stroke: 'green',
                    },
                    '& .MuiCircularProgress-circleBackground': {
                      stroke: 'yellow',
                    },
                  }}
                />
              </Box>
            </Box>
          </CardContent>
        </Card>

        {/* Title Card */}
        <Card>
          <CardContent>
            <Typography variant="subtitle1" color="textSecondary" gutterBottom>
              Title goes here
            </Typography>
            <Typography variant="h5" fontWeight="bold">
              {analysischarts.owners_transfer}
            </Typography>
            <Box flex={1} ml={2} display="flex" justifyContent="center" alignItems="center" marginTop={2}>
              <LinearProgress
                variant="determinate"
                value={75}
                color="success"
                sx={{
                  height: 8,
                  width: '70%',
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: 'green',
                  },
                  '& .MuiLinearProgress-dashed': {
                    backgroundColor: '#FFA150',
                  },
                }}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>

      <Box sx={{ p: 3, direction: 'ltr' }}>


        <Card>
          <Typography sx={{ marginLeft: "10px", marginTop: "10px" }} variant="h6">Analysis</Typography>
          <CardContent>
            <TableContainer component={Paper}>
              <Table>
                <TableHead style={{ backgroundColor: '#F2F4F7' }}>
                  <TableRow>
                    <TableCell>Profile</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Unit Name</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedData.map((record, index) => (
                    <TableRow
                      key={index}
                      sx={{ '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' } }}
                    >
                      <TableCell align="center">
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <Avatar src={record.owner_image} alt={record.owner_name} sx={{ mr: 2 }} />
                        </Box>
                      </TableCell>
                      <TableCell>{record.owner_name}</TableCell>
                      <TableCell>{record.unit_name}</TableCell>
                      <TableCell>
                        <Chip
                          label={record.status}
                          color={record.status === 'paid' ? 'success' : 'error'}
                          sx={{
                            borderRadius: '16px',
                            '& .MuiChip-label': {
                              px: 2,
                            },
                          }}
                        />
                      </TableCell>
                      <TableCell>{record.booking_date}</TableCell>
                      <TableCell>{record.payment}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 15]}
              component="div"
              count={analysis.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default Analysis;
